/*
 * Copyright (c) Dito Technologies LLC
 */

import {graphql} from "babel-plugin-relay/macro";
import {
    UpdatePieceFileChangeNoteDurationMutation$variables
} from "mutation/__generated__/UpdatePieceFileChangeNoteDurationMutation.graphql";
import perform from "mutation/perform";

const mutation = graphql`
    mutation UpdatePieceFileChangeNoteDurationMutation($input: MusicUpdatePieceFileChangeNoteDurationInput!) {
        music_update_piece_file_change_note_duration(input: $input) {
            piece {
                id
                ...PiecePlayBody_piece
            }
        }
    }
`;

export default function UpdatePieceFileChangeNoteDuration(pieceId: string, bulbId: string, noteDuration: number) {
    const variables: UpdatePieceFileChangeNoteDurationMutation$variables = {
        input: {
            piece_id: pieceId,
            bulb_id: bulbId,
            note_duration: noteDuration
        }
    };
    return perform(mutation, variables);
}